module.exports = __webpack_public_path__ + "media/recommendations.79df2f6f.mp4";